import { FC } from 'react'
import useShortsContext from 'contexts/ShortsContext/hook'
import StreakCounter from 'components/StreakCounter'
import { Link } from 'react-router-dom'
import { Adsense } from '@ctrl/react-adsense'
import siteConfig from 'config'

interface props {
  hide: () => void
}

const ShortsSidebarContent: FC<props> = ({ hide }) => {
  const { subjectName } = useShortsContext()

  return (
    <div className="w-full flex flex-col grow animate-fade-in">
      <span className="text-lg bg-yellow-200 rounded-xl text-kura p-4 font-semibold w-full text-center leading-[130%] mt-8">{subjectName} - Shorts</span>
      <div className="px-12">
        <StreakCounter />
      </div>
      <div className="grow w-full p-4">
        <div style={{ position: 'relative', width: '100%', maxWidth: '100%' }}>
          <Adsense
            client="ca-pub-7116882657059239"
            slot="4664278820"
            style={{ display: 'block', textAlign: 'center', position: 'absolute', width: 'inherit', maxWidth: 'inherit' }}
            layout="in-article"
            format="auto"
          />
        </div>
      </div>
      <div>
        <Link className="button-primary mt-4" to="/shorts" onClick={hide}>
          {siteConfig.labels.shorts.finish}
        </Link>
      </div>
    </div>
  )
}

export default ShortsSidebarContent
